/** Joining by invitation: who invited you, the terms in full, an account of your own. */
import { useEffect, useState } from 'react'
import { invitesApi } from './api'
import { WorkspaceMark } from './icons'
import { Btn, Field, inputCls } from './kit'

export function Join({ token }: { token: string }) {
  const [from, setFrom] = useState<string | null>(null)
  const [bad, setBad] = useState('')
  const [terms, setTerms] = useState<{ version: string; text: string } | null>(null)
  const [name, setName] = useState('')
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [agreed, setAgreed] = useState(false)
  const [busy, setBusy] = useState(false)
  const [problem, setProblem] = useState('')
  useEffect(() => {
    invitesApi.check(token).then((r) => setFrom(r.from), (e) => setBad(e instanceof Error ? e.message : 'This invitation cannot be used.'))
    invitesApi.terms().then(setTerms, () => {})
  }, [token])
  const ok = /^[a-zA-Z0-9_.-]{3,32}$/.test(username.trim()) && password.length >= 8 && agreed && !!terms
  const submit = async () => {
    if (!ok || busy || !terms) return
    setBusy(true)
    setProblem('')
    try {
      await invitesApi.join({ token, username: username.trim(), password, name: name.trim() || undefined, terms: terms.version })
      window.location.replace('/') // signed in: the app opens
    } catch (e) {
      setProblem(e instanceof Error ? e.message : 'That did not work')
      setBusy(false)
    }
  }
  return (
    <div className="ws flex min-h-full justify-center overflow-y-auto bg-ws-bg px-4 py-10">
      <form
        className="w-full max-w-[460px] self-center"
        onSubmit={(e) => {
          e.preventDefault()
          void submit()
        }}
      >
        <div className="flex flex-col items-center">
          <WorkspaceMark size={28} />
          <h1 className="m-0 mt-5 text-center font-ws-serif text-[28px] font-normal leading-9 tracking-normal text-ws-fg">{bad ? 'This invitation cannot be used' : from ? `${from} invited you` : 'Liberabank'}</h1>
          <p className="m-0 mt-2 max-w-[380px] text-center text-[12px] leading-[18px] tracking-normal text-ws-fg-3">{bad ? bad : 'A Liberabank of your own: your agents, your memory, your accounts. Nobody else sees them, and nothing you do here is done for you by anyone else.'}</p>
        </div>
        {!bad && (
          <>
            <div className="mt-8 space-y-4">
              <Field label="Your name" hint="Optional">
                <input value={name} onChange={(e) => setName(e.target.value)} className={inputCls} autoComplete="name" />
              </Field>
              <Field label="Username" hint="Letters, digits, . - _">
                <input value={username} onChange={(e) => setUsername(e.target.value)} className={inputCls} autoComplete="username" autoCapitalize="none" spellCheck={false} />
              </Field>
              <Field label="Password" hint="At least 8 characters">
                <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" className={inputCls} autoComplete="new-password" />
              </Field>
            </div>
            <h2 className="m-0 mb-[6px] mt-6 text-[12px] font-normal leading-4 tracking-normal text-ws-label">The terms</h2>
            <div className="max-h-[220px] overflow-y-auto whitespace-pre-wrap rounded-[8px] border border-ws-line px-3 py-[10px] text-[12px] leading-[18px] tracking-normal text-ws-fg-2">{terms?.text ?? 'Loading…'}</div>
            <label className="mt-3 flex cursor-pointer items-start gap-3 text-[13px] leading-5 tracking-normal text-ws-fg-2">
              <input type="checkbox" checked={agreed} onChange={(e) => setAgreed(e.target.checked)} className="mt-[3px] h-4 w-4 shrink-0 accent-white" />
              I have read these terms and I accept them for myself.
            </label>
            {problem && <p className="m-0 mt-4 text-[12px] leading-[18px] tracking-normal text-ws-down">{problem}</p>}
            <Btn variant="white" type="submit" disabled={!ok || busy} className="mt-6 w-full">
              {busy ? 'One moment…' : 'Create my account'}
            </Btn>
          </>
        )}
      </form>
    </div>
  )
}
